import { render, staticRenderFns } from "./PageForgetPassword.vue?vue&type=template&id=0ac9488a&scoped=true&"
import script from "./PageForgetPassword.vue?vue&type=script&lang=js&"
export * from "./PageForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./PageForgetPassword.vue?vue&type=style&index=0&id=0ac9488a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac9488a",
  null
  
)

export default component.exports